import React from "react";
import { Divider } from "antd";
import {
  Content,
  Head,
  ConnectName,
  Text,
  Title,
} from "../../ModalStyled.styled";
import moment from "moment";
import { ErrorIcon } from "./../../../../_assests";

export default function PeriodWarning({ connectName, periodStart, periodEnd }) {
  return (
    <Content>
      <Head>
        <ErrorIcon />
        <Title>Период передачи показаний закрыт</Title>
      </Head>
      <Divider />
      <ConnectName>{connectName}</ConnectName>
      <Text>
        Передача показаний доступна с{" "}
        {`${moment(periodStart).format("D")} по ${moment(periodEnd).format(
          "D"
        )} число`}
      </Text>
    </Content>
  );
}
